import React, { useEffect, useState } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

const Purchase_Order = () => {
   useAuthRedirect();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;

  const [data, setData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

            /////////////////////////////////////////////////////////////     
            const canView  = hasPermission("Purchase order", "view");
            const canEntry = hasPermission("Purchase order", "entry");
            /////////////////////////////////////////////////////////////
       

  useEffect(() => {
    fetchData();
  }, [ selectedYear, selectedMonth]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/purchaseOrder_list", {
        params: {  month: selectedMonth, year: selectedYear }
      });
      setData(response.data.purchaseOrderList);
      setFilteredData(response.data.purchaseOrderList);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.PurchaseOrderHeader_ponumber || "").toLowerCase().includes(term) ||
       String(item.supplierMaster_Name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

 
   if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Purchase Orders</h2>
          <Time />
        </section>

        {canEntry && (
        <div className="next-container">
          <Link to={`/inventory/grnmenu`}>
            <button className="next-btn">
                 Next GRN<i className="fa-solid fa-arrow-right"></i> 
            </button>
          </Link>
        </div>
        )}


        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map(i => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map(i => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>

          <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/inventory/purchaseOrderView';
  }}
>
  View All
</button>
        </div>

        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/addPurchaseOrder`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by PO No & Supplier"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>P.O No</th>
                <th>P.O Date</th>
                <th>Branch</th>
                <th>Supplier</th>
                <th>Your Ref</th>
                <th>Your Ref Date</th>
                <th>Value</th>
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/purchaseorderviewSingle/${item.PurchaseOrderHeader_ponumber}`}>
                        {item.PurchaseOrderHeader_ponumber}
                      </Link>
                    </td>
                    <td>{new Date(item.PurchaseOrderHeader_podate).toLocaleDateString()}</td>
                    <td>{item.Branchcode}</td>
                    <td>{item.supplierMaster_Name}</td>
                    <td>{item.PurchaseOrderHeader_YourReferencenumber}</td>
                    <td>{new Date(item.PurchaseOrderHeader_YourReferenceDate).toLocaleDateString()}</td>
                    <td>{item.PurchaseOrderHeader_TotalValue}</td>
                    <td>
                      <Link target="_blank" to={`/inventory/purchaseorderpriview/${item.PurchaseOrderHeader_ponumber}`}>
                      <i class="fa-solid fa-print edit"></i>
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Purchase_Order;
